import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { loginGuardProvider } from './guards/login.guard';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { PolicyPrivacityComponent } from './pages/policy-privacity/policy-privacity.component';

export const routes: Routes = [
    { path: '', redirectTo: "auth", pathMatch: 'full' },
    { path: 'auth', component: LoginComponent, canActivate: [loginGuardProvider] },
    { path: 'terms-conditions', component: TermsConditionsComponent},
    { path: 'policy-privacity', component: PolicyPrivacityComponent},

    {
        path: 'admin',
        component: AppLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./pages/pages.module')
                    .then(mod => mod.PagesModule),
            },
        ],
        data: {
            prerender: false
        }
    },
    //{ path: 'admin', component: HomeComponent, canActivate: [loginGuardProvider] },
];
